<!--
  -  Copyright (c) Qwoach LLC 2021. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 30/11/2021
  -->

<template>
	<div class="qw-row flex-nowrap qw-input-search-root height-input-standard qwoach-form input-background relative"
		 style="padding: 0 !important;">

		<div class="overflow-hidden">

			<transition
				:name="transitionName"
				:duration="transitionAnimationDuration"
				@after-leave="onTransitionCompleted"
				@after-enter="onTransitionCompleted">

				<qw-input
					ref="inputView"
					v-if="!collapsable || !isCollapsed"
					v-bind="$attrs"
					style="padding-left: 14px;"
					:style="{width: widthInput}"
					:input-debounce-delay="1000"
					:placeholder="placeholder"
				/>
			</transition>
		</div>

		<div
			@click="toggleCollapse"
			class="cursor-pointer"
			style="padding: 0 14px;">

			<div class="qw-input-search-button el-input__suffix relative"
				 style="right: 0">
				<i v-if="isCollapsed" class="fontello icon-search"/>
				<i v-else class="fontello  icon-cancel-circled2"/>
			</div>
		</div>

	</div>

</template>

<script>

import DebouncedVModelView from "@/core/components/DebouncedVModelView.vue";

export default {
	name: "qw-input-search",
	extends: DebouncedVModelView,
	inheritAttrs: false,


	props: {
		widthInput: String,
		collapsable: Boolean,
		placeholder: {String, default: "Type to search"},
		isExpanded: Boolean,

	},

	data() {
		return {
			isCollapsed: true,
			transitionName: null,
			transitionAnimationDuration: 150,
		}
	},

	created() {
		this.isCollapsed = !this.isExpanded
	},

	methods: {
		setCollapsed(isCollapsed){
			if(this.isCollapsed !== isCollapsed){
				this.toggleCollapse()
			}
		},
		async toggleCollapse() {
			this.transitionName = this.isCollapsed ? 'slide' : 'slideBack'
			await this.$nextTickPromise()
			this.isCollapsed = !this.isCollapsed
			if (!this.isCollapsed) {
				this.$emit("collapseChange", this.isCollapsed)
				this.focusSearchInput()
			}
		},

		focusSearchInput() {
			//we need to wait for the animation to finish before focusin. Otherwise this produces visual glitch
			setTimeout(() => {
				if(this.$refs.inputView){
					this.$refs.inputView.focus()
				}
			}, this.transitionAnimationDuration)
		},

		onTransitionCompleted() {
			this.$emit("collapseChange", this.isCollapsed)
		}
	},
}
</script>

<style lang="scss">
.qw-input-search-root {

	.el-input__suffix {
		cursor: pointer;
		//border-radius: 50%;
		//width: 1.8rem;
		//height: 1.8rem;
	}

	.el-input__suffix:hover {
		//background-color: rgba(0, 0, 0, 0.04);
	}

	.qw-input-search-button {
		.el-input__icon {
			width: 21px;
		}
	}
}

</style>
